import {
    ACCORDION_BASE_CLASSNAME,
    createAccordion,
    IAccordionBusinessLogic,
    IAccordionItemProperties,
} from '@vfde-brix/ws10/accordion';
import {
    createComponents,
    stripHtml,
} from '@vfde-brix/ws10/core';
import {
    normalizeTrackingPayloadName,
    TRACKING_INFORMATION_ACTION_REVEAL,
    TrackingInformation,
    TrackingInformationTrigger,
    TrackingInformationUiType,
    trackIt,
    TrackType,
} from '@vfde-sails/tracking';

/**
 * Mount all other editorial accordions
 */
export const mountAccordions = () => {
    const business: IAccordionBusinessLogic = {
        onToggle: itemProperties => {
            const { eventType, eventPayload } = createTrackingPayloadForAccordion(itemProperties);

            // Only track if accordion item opens
            return itemProperties.optOpen && trackIt(eventType, eventPayload);
        },
    };

    createComponents(`.${ACCORDION_BASE_CLASSNAME}`, createAccordion, business);
};

/**
 * Create tracking payload for accordion item
 */
export const createTrackingPayloadForAccordion = (
    properties: IAccordionItemProperties,
): { eventType: TrackType, eventPayload: TrackingInformation } => ({
    eventType: TrackType.Information,
    eventPayload: {
        /* eslint-disable camelcase, @typescript-eslint/naming-convention */
        information_action: TRACKING_INFORMATION_ACTION_REVEAL,
        information_ui_type: TrackingInformationUiType.Faq,
        information_trigger: TrackingInformationTrigger.Accordion,
        information_name: normalizeTrackingPayloadName(stripHtml(properties.stdHeadline)),
        /* eslint-enable camelcase, @typescript-eslint/naming-convention */
    },
});
